import React from "react";
import Head from "next/head";
import { NextSeo } from "next-seo";
import { seoFunct } from "../../config/next-seo.config.js";
import { withRouter } from "next/router";
import HomeNav from "../Home/HomeNav.jsx";
import HomeFooter from "../Home/HomeFooter.jsx";
import FeaturesCard from "../../revampComponents/FeaturesCard";
import Banner from "../../revampComponents/Banner";
import revampData from "../../data/revampData.json";
import FeatureIntroSection from '../Features/FeatureIntroSection.jsx';
import Introduction from "../../revampComponents/Introduction";
const TapPaymets = () => {
  const conncettappaymentFeatures = revampData.data.listConnectWithTapFeatureCards.data;
  const conncettappaymentBanner = revampData.data.listConnectWithTapCallToActionsBanner.data;
  const conncettappaymentIntro = revampData.data.listConnectWithTapIntros.data;
  return <div className="font-figtree" data-sentry-component="TapPaymets" data-sentry-source-file="TapPayments.jsx">
      <NextSeo {...seoFunct("revampTapPaymentsSeo")} data-sentry-element="NextSeo" data-sentry-source-file="TapPayments.jsx" />
      <HomeNav data-sentry-element="HomeNav" data-sentry-source-file="TapPayments.jsx" />
      <Introduction data={conncettappaymentIntro} buttons={true} data-sentry-element="Introduction" data-sentry-source-file="TapPayments.jsx" />
      <FeaturesCard featuresData={conncettappaymentFeatures} swapCard={true} displayScroll={true} data-sentry-element="FeaturesCard" data-sentry-source-file="TapPayments.jsx" />
      <Banner bannerData={conncettappaymentBanner} data-sentry-element="Banner" data-sentry-source-file="TapPayments.jsx" />
      <HomeFooter data-sentry-element="HomeFooter" data-sentry-source-file="TapPayments.jsx" />

      <style jsx>{`
        .main-container {
          max-width: 1400px;
          width: 100%;
        }
      `}</style>
    </div>;
};
export default withRouter(TapPaymets);